// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"9767aeba6de128d0","777":"be4c83b0fda3d307","925":"13f92ed1009800b1"}[chunkId] + ".js";
};